import * as ACTION_TYPES from './Types';

const initialState = {
  products: {},
  message: '',
  error: null,
  productDetails: {}
}

export const productReducer = (state = initialState, action) => {
  switch (action.type) {



    case ACTION_TYPES.GETPRODUCT_SUCCESS:
      return {
        ...state,
        products: action.payload.data,
        message: action.payload.message,
      }

    case ACTION_TYPES.GETPRODUCT_ERROR:
      return {
        ...state,
        message: action.payload.message,
      }
    case ACTION_TYPES.GET_PROD_DETAILS_SUCCESS:
      return {
        ...state,
        productDetails: action.payload.data,
        message: action.payload.message,
      }

    case ACTION_TYPES.GET_PROD_DETAILS_ERROR:
      return {
        ...state,
        productDetails: {},
        message: action.payload.message,
      }
    case ACTION_TYPES.ADDPRODUCT_SUCCESS:
    case ACTION_TYPES.UPDATEPRODUCT_SUCCESS:
    case ACTION_TYPES.CHANGEACTION_SUCCESS:
      return {
        ...state,
        categories: action.payload.data,
        message: action.payload.message,
      }

    case ACTION_TYPES.ADDPRODUCT_ERROR:
    case ACTION_TYPES.UPDATEPRODUCT_ERROR:
    case ACTION_TYPES.CHANGEACTION_ERROR:
      return {
        ...state,
        message: action.payload.message,
      }

    default:
      return state;
  }
}
